import { NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export const importantPushEnum: NotificationType[] = [
  NotificationType.LIVECHAT_INVITATION_CREATED,
  NotificationType.LIVECHAT_INVITATION_DECLINED,
];
